import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import Markdown from "markdown-to-jsx";

const Paragraph = forwardRef(({ t, nr }, ref) => (
  <div ref={ref} id={t.id} className="Paragraph">
    <p className="Paragraph__title">
      §{nr}. {t.title}
    </p>
    <Markdown>{t.description}</Markdown>
  </div>
));

Paragraph.propTypes = {
  t: PropTypes.object.isRequired,
  nr: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default Paragraph;
